import z from 'zod';

import { getRequestHeaders } from '../portalApiClient';
import Session from '../Session';

import { getMessageFromResponse } from './errorHelper';

const RefreshTokenResponse = z.object({
  token: z.string(),
});

type RefreshTokenResponse = z.infer<typeof RefreshTokenResponse>;

export async function refreshAuthToken(
  session: Session
): Promise<RefreshTokenResponse> {
  try {
    const client = session.getPortalApiClientOrThrow(
      'Error refreshing auth token - client not ready.'
    );
    const response = await client.http.request({
      path: '/api/v1/refresh',
      headers: {
        ...getRequestHeaders(session),
        authorization: `Bearer ${session.getRefreshToken()}`,
      },
      method: 'POST',
      // disable security worker as we pass our own headers
      secure: false,
    });
    if (!response?.ok) {
      const message = await getMessageFromResponse(response);
      throw new Error(message ?? 'Refreshing auth token failed.');
    }
    const res = await response.json();
    return RefreshTokenResponse.parse(res);
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
